<div *ngIf="company">
    <p-dialog header="Setup Team" [contentStyle]="{'overflow': 'visible'}"  [(visible)]="visible"  [modal]="true" [style]="{width: '500px'}" (onHide)="onHide()">
        <b>Action Required:</b> Please setup the required team members on <a [href]="sharePointURL" target="_blank" rel="noopener noreferrer">SharePoint</a>; <b>{{ getMissingTeamRolesString() }}</b> 
    </p-dialog>
</div>